import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl'
import CalculatorTermsForm from './calculator/terms.component.jsx'
import CalculatorFormulasForm from './calculator/formulas.component.jsx'
const uuidv4 = require('uuid/v4')

class ConstraintEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            assembly: this.props.assembly || null,
            terms: [],
            formulas: []
        }

        this.onChange = this.props.onChange || function () {}
        this.handleTermsChange = this.handleTermsChange.bind(this)
        this.handleFormulasChange = this.handleFormulasChange.bind(this)
    }

    handleTermsChange(value) {
        this.setState({
            terms: value
        }, this.valueChanged)
    }

    handleFormulasChange(value) {
        this.setState({
            formulas: value
        }, this.valueChanged)
    }

    valueChanged() {
        this.onChange(this.state.terms)
    }

    searchFormulaIndexByPartId(partId) {
        for (let index in this.state.formulas) {
            if (this.state.formulas[index].partId === partId) {
                return index
            }
        }
        return -1
    }

    refreshFormulaInputs() {
        let formulas = this.state.formulas
        if (this.state.assembly) {
            for (let i in this.state.assembly.parts) {
                const part = this.state.assembly.parts[i]
                const y = this.searchFormulaIndexByPartId(part.id)
                if (y !== -1) {
                    formulas[y].partName = part.name
                } else {
                    formulas.push({
                        formula: '',
                        partId: part.id,
                        partName: part.name,
                        calculatorFormulaId: uuidv4(),
                        simulation: '',
                    })
                }
            }
            const partIds = this.state.assembly.parts.map(p => p.id)
            formulas = formulas.filter(f => partIds.indexOf(f.partId) !== -1)
        } else if (formulas.length === 0) {
            formulas.push({
                formula: '',
                partId: '',
                partName: '',
                calculatorFormulaId: uuidv4(),
                simulation: '',
            })
        }
        this.setState({
            formulas: formulas
        })
    }

    componentDidMount() {
        this.setState({
            terms: this.props.value || []
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            terms: nextProps.value || []
        })
    }

    render() {
        return (
            <div className="col-12 ui-module">
                <h5>
                    <FormattedMessage
                        id="product.calculator.form.edit.title"
                        defaultMessage="Constraint for calculator"
                    />
                </h5>
                <div className="row">
                    <div className="col-12">
                        <h6>
                            <u>
                                <FormattedMessage
                                    id="product.calculator.form.edit.list_of_terms_label"
                                    defaultMessage="Constraints :"
                                />
                            </u>
                        </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <CalculatorTermsForm onChange={this.handleTermsChange} value={this.state.terms} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ConstraintEditForm


// WEBPACK FOOTER //
// ./src/product/form/constraints.component.jsx